///
/// EarthBrowser
///
/// Created by Matt Giger on 1/11/2025
/// Copyright (c) 2025 Geodata Labs
///

import { format } from "date-fns"

export function DateField({ value }: { value: string }) {
	return <p className="text-sm text-muted-foreground font-bold ml-1">{format(new Date(value), "MM/dd/yyyy")}</p>
}
